import create, { StoreApi } from "zustand";

import { ToastData } from "@/v1/types/global";

interface IUseToastStoreState {
  toast: ToastData | null;
}

interface IUseToastStore extends IUseToastStoreState {
  set: StoreApi<IUseToastStoreState>["setState"];
}

export const useToastStore = create<IUseToastStore>(set => ({
  toast: null,
  set,
}));
